<template>
  <generic-modal
    size="medium"
    :title="$t('professor configuration')"
    icon="book"
    image="/images/icons/professor.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui four item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="professions">{{
          $t("professions")
        }}</a>
        <a class="item" data-tab="professional_colleges">{{
          $t("professional colleges")
        }}</a>
        <a class="item" data-tab="tax_regimes">{{ $t("tax regimes") }}</a>
        <a class="item" data-tab="attributes">{{ $t("attributes") }}</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="professions">
        <professions ref="professions" />
      </div>
      <div
        class="ui bottom attached tab segment"
        data-tab="professional_colleges"
      >
        <professional-colleges ref="professional_colleges" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="tax_regimes">
        <tax-regimes ref="tax_regimes" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="attributes">
        <attributes ref="attributes" />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import Attributes from "./Attributes";
import Professions from "./Professions";
import ProfessionalColleges from "./ProfessionalColleges";
import TaxRegimes from "./TaxRegimes";

export default {
  components: {
    "generic-modal": GenericModal,
    Attributes,
    Professions,
    ProfessionalColleges,
    TaxRegimes,
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let attributes = vm.$refs.attributes.getList();
        let professions = vm.$refs.professions.getList();
        let professional_colleges = vm.$refs.professional_colleges.getList();
        let tax_regimes = vm.$refs.tax_regimes.getList();
        local_api(vm, "post", "/professor/setting/do-save-configuration", {
          s: {
            attributes: attributes,
            professions: professions,
            professional_colleges: professional_colleges,
            tax_regimes: tax_regimes,
          },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/professor/setting/do-get-configuration")
      .then((conf) => {
        if (conf && conf.setup && conf.setup.attributes) {
          vm.$refs.attributes.setList(conf.setup.attributes);
        }
        if (conf && conf.setup && conf.setup.professions) {
          vm.$refs.professions.setList(conf.setup.professions);
        }
        if (conf && conf.setup && conf.setup.professional_colleges) {
          vm.$refs.professional_colleges.setList(
            conf.setup.professional_colleges,
          );
        }
        if (conf && conf.setup && conf.setup.tax_regimes) {
          vm.$refs.tax_regimes.setList(conf.setup.tax_regimes);
        }
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
};
</script>
